module.exports = __webpack_public_path__ + "static/media/hongbao_icon.1d37a306.png";